import { useEffect } from 'react';
import { trackGptCTAClick } from '../utils/analytics';

const GPT_HOST = 'chatgpt.com';

/** Placement for a GPT link: header and footer keep stable names; anything
 *  else on the page is "page_cta". */
export function gptPlacement(link: Element): string {
  if (link.closest('header')) return 'header_cta';
  if (link.closest('footer')) return 'footer_cta';
  return 'page_cta';
}

/**
 * Sends a `gpt_cta_click` event for every click on a link to the custom GPT
 * (chatgpt.com), wherever it is rendered. One delegated listener instead of
 * per-link onClick handlers, so CTAs added later are tracked automatically.
 */
export default function GptClickTracker() {
  useEffect(() => {
    const onClick = (e: MouseEvent) => {
      const link = (e.target as Element | null)?.closest?.('a[href]');
      if (!link) return;
      let host = '';
      try { host = new URL((link as HTMLAnchorElement).href).hostname; } catch { return; }
      if (host !== GPT_HOST) return;
      trackGptCTAClick(gptPlacement(link), {
        page_path: window.location.pathname,
        link_text: (link.textContent || '').trim().slice(0, 80),
      });
    };
    document.addEventListener('click', onClick, true);
    return () => document.removeEventListener('click', onClick, true);
  }, []);
  return null;
}
